/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {TagService} from "../services/tag.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";
import { TagDefinition } from "app/models/tag-definition";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class TagDefinitionsPagingResolver implements Resolve<PagedResults<TagDefinition>> {

  constructor(
    private mTagService: TagService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<TagDefinition>> {
    try {
      return await this.mTagService.getAllTagsForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Tag Definitions... Error: " + error, error);
    }
  }

}
